interface Props {
  lastRefreshed: Date | null;
  refreshing: boolean;
}

function ago(d: Date): string {
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 5) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  return `${m}m ago`;
}

export function Footer({ lastRefreshed, refreshing }: Readonly<Props>) {
  let statusLabel: string;
  if (refreshing) {
    statusLabel = 'Refreshing…';
  } else if (lastRefreshed) {
    statusLabel = `Last updated ${ago(lastRefreshed)}`;
  } else {
    statusLabel = 'Loading…';
  }
  return (
    <footer className="mt-12 flex flex-wrap items-center justify-between gap-3 border-t border-[var(--color-border-subtle)] pt-6 font-mono text-xs text-[var(--color-fg-muted)]">
      <div>{statusLabel}</div>
      <div className="text-[var(--color-fg-subtle)]">
        Probes every 30s · page refresh every 60s
      </div>
    </footer>
  );
}
